import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { GHG_ESTIMATOR_CONCEPT_ID, IMPACT_CARRY_CONCEPT_ID, IMPACT_STRATEGY_CONCEPT_ID } from '~/constants/concepts';
import { questionnaireVersionTextShort } from '~/functions/esg';
import { downloadPdf, downloadZip } from '~/functions/export';
import { FileFormat, Module, ReviewCompanyPdfSection, useExportCompanyTypstPdfLazyQuery, useGetAccountQuery, useGetImpactGoalQuery, useGetQuestionnairesForVenturesAndLabelQuery } from '~/types/types';
/** Shared availability for company Typst export menu + dialog. */
export function useCompanyTypstExportAvailability(ventureId) {
  var ventureIdRef = computed(function () {
    return typeof ventureId === 'string' ? ventureId : ventureId.value;
  });
  var _useGetAccountQuery = useGetAccountQuery(computed(function () {
      return {
        id: ventureIdRef.value
      };
    }), computed(function () {
      return {
        enabled: !!ventureIdRef.value
      };
    })),
    accountResult = _useGetAccountQuery.result,
    accountLoading = _useGetAccountQuery.loading;
  var hasImpactStrategyModule = computed(function () {
    var _accountResult$value, _accountResult$value$, _accountResult$value$2;
    return !!((_accountResult$value = accountResult.value) !== null && _accountResult$value !== void 0 && (_accountResult$value$ = _accountResult$value.getAccount) !== null && _accountResult$value$ !== void 0 && (_accountResult$value$2 = _accountResult$value$.bookedModules) !== null && _accountResult$value$2 !== void 0 && _accountResult$value$2.includes(Module.ImpactStrategy));
  });
  var hasImpactGoalModule = computed(function () {
    var _accountResult$value2, _accountResult$value3, _accountResult$value4;
    return !!((_accountResult$value2 = accountResult.value) !== null && _accountResult$value2 !== void 0 && (_accountResult$value3 = _accountResult$value2.getAccount) !== null && _accountResult$value3 !== void 0 && (_accountResult$value4 = _accountResult$value3.bookedModules) !== null && _accountResult$value4 !== void 0 && _accountResult$value4.includes(Module.ImpactGoal));
  });
  var hasEsgModule = computed(function () {
    var _accountResult$value5, _accountResult$value6, _accountResult$value7;
    return !!((_accountResult$value5 = accountResult.value) !== null && _accountResult$value5 !== void 0 && (_accountResult$value6 = _accountResult$value5.getAccount) !== null && _accountResult$value6 !== void 0 && (_accountResult$value7 = _accountResult$value6.bookedModules) !== null && _accountResult$value7 !== void 0 && _accountResult$value7.includes(Module.Esg));
  });
  var accountModulesResolved = computed(function () {
    var _accountResult$value8;
    return !!((_accountResult$value8 = accountResult.value) !== null && _accountResult$value8 !== void 0 && _accountResult$value8.getAccount);
  });
  var shouldFetchImpactGoal = computed(function () {
    return accountModulesResolved.value && (hasImpactStrategyModule.value || hasImpactGoalModule.value);
  });
  var _useGetImpactGoalQuer = useGetImpactGoalQuery(computed(function () {
      return {
        ventureId: ventureIdRef.value
      };
    }), computed(function () {
      return {
        enabled: !!ventureIdRef.value && shouldFetchImpactGoal.value
      };
    })),
    impactGoalResult = _useGetImpactGoalQuer.result,
    impactGoalLoading = _useGetImpactGoalQuer.loading;
  var _useGetQuestionnaires = useGetQuestionnairesForVenturesAndLabelQuery(computed(function () {
      return {
        ventureIds: [ventureIdRef.value],
        label: 'ESG'
      };
    }), computed(function () {
      return {
        enabled: !!ventureIdRef.value && accountModulesResolved.value && hasEsgModule.value
      };
    })),
    questionnairesResult = _useGetQuestionnaires.result,
    questionnairesLoading = _useGetQuestionnaires.loading;
  var completedEsgQuestionnaires = computed(function () {
    var _questionnairesResult;
    return (((_questionnairesResult = questionnairesResult.value) === null || _questionnairesResult === void 0 ? void 0 : _questionnairesResult.getQuestionnairesForVenturesAndLabel) || []).filter(function (item) {
      return item.isEditable === false;
    }).map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        text: questionnaireVersionTextShort(item)
      });
    });
  });
  var impactConceptIds = computed(function () {
    var _impactGoalResult$val, _impactGoalResult$val2;
    return new Set((((_impactGoalResult$val = impactGoalResult.value) === null || _impactGoalResult$val === void 0 ? void 0 : (_impactGoalResult$val2 = _impactGoalResult$val.getImpactGoal) === null || _impactGoalResult$val2 === void 0 ? void 0 : _impactGoalResult$val2.impacts) || []).map(function (impact) {
      return Number(impact.conceptId);
    }));
  });
  var availability = computed(function () {
    return {
      strategy: impactConceptIds.value.has(IMPACT_STRATEGY_CONCEPT_ID),
      carry: impactConceptIds.value.has(IMPACT_CARRY_CONCEPT_ID),
      ghg: impactConceptIds.value.has(GHG_ESTIMATOR_CONCEPT_ID),
      esg: completedEsgQuestionnaires.value.length > 0
    };
  });
  var loading = computed(function () {
    return accountLoading.value || shouldFetchImpactGoal.value && impactGoalLoading.value || hasEsgModule.value && questionnairesLoading.value;
  });
  var availableOptions = computed(function () {
    var options = [];
    if (hasImpactStrategyModule.value && availability.value.strategy) {
      options.push({
        key: 'strategy',
        section: ReviewCompanyPdfSection.Strategy
      });
    }
    if (hasImpactStrategyModule.value && availability.value.carry) {
      options.push({
        key: 'carry',
        section: ReviewCompanyPdfSection.Carry
      });
    }
    if (hasImpactGoalModule.value && availability.value.ghg) {
      options.push({
        key: 'ghg',
        section: ReviewCompanyPdfSection.Ghg
      });
    }
    if (hasEsgModule.value && availability.value.esg) {
      var _latest$id;
      var latest = completedEsgQuestionnaires.value[0];
      options.push({
        key: 'esg',
        questionnaireId: (_latest$id = latest === null || latest === void 0 ? void 0 : latest.id) !== null && _latest$id !== void 0 ? _latest$id : undefined
      });
    }
    return options;
  });
  return {
    loading: loading,
    hasImpactStrategyModule: hasImpactStrategyModule,
    hasImpactGoalModule: hasImpactGoalModule,
    hasEsgModule: hasEsgModule,
    availability: availability,
    completedEsgQuestionnaires: completedEsgQuestionnaires,
    availableOptions: availableOptions
  };
}

/** Run company Typst PDF/zip download for the given sections. */
export function useCompanyTypstPdfDownload(ventureId) {
  var _useExportCompanyTyps = useExportCompanyTypstPdfLazyQuery({
      input: {
        ventureId: ventureId.value || '',
        sections: [ReviewCompanyPdfSection.Strategy]
      }
    }, {
      fetchPolicy: 'network-only'
    }),
    loadImpactExport = _useExportCompanyTyps.load,
    refetchImpactExport = _useExportCompanyTyps.refetch,
    exporting = _useExportCompanyTyps.loading;
  var runCompanyTypstExport = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(variables) {
      var loadResult, refetchResult;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            loadResult = loadImpactExport(null, variables);
            if (!(loadResult instanceof Promise)) {
              _context.next = 5;
              break;
            }
            _context.next = 4;
            return loadResult;
          case 4:
            return _context.abrupt("return", _context.sent);
          case 5:
            _context.next = 7;
            return refetchImpactExport(variables);
          case 7:
            refetchResult = _context.sent;
            return _context.abrupt("return", refetchResult === null || refetchResult === void 0 ? void 0 : refetchResult.data);
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function runCompanyTypstExport(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var downloadTypstOption = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(option) {
      var id, data, file;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            id = ventureId.value;
            if (id) {
              _context2.next = 3;
              break;
            }
            throw new Error('Missing venture id');
          case 3:
            if (!(option.key === 'esg' && option.questionnaireId == null)) {
              _context2.next = 5;
              break;
            }
            throw new Error('Missing ESG questionnaire');
          case 5:
            _context2.next = 7;
            return runCompanyTypstExport({
              input: _objectSpread({
                ventureId: id,
                sections: option.section ? [option.section] : []
              }, option.questionnaireId != null ? {
                questionnaireId: option.questionnaireId
              } : {})
            });
          case 7:
            data = _context2.sent;
            file = data === null || data === void 0 ? void 0 : data.exportCompanyTypstPdf;
            if (!(!(file !== null && file !== void 0 && file.base64String) || !file.fileName)) {
              _context2.next = 11;
              break;
            }
            throw new Error('Missing export payload');
          case 11:
            if (file.format === FileFormat.Zip) {
              downloadZip(file.base64String, file.fileName);
            } else {
              downloadPdf(file.base64String, file.fileName);
            }
          case 12:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function downloadTypstOption(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  return {
    exporting: exporting,
    runCompanyTypstExport: runCompanyTypstExport,
    downloadTypstOption: downloadTypstOption
  };
}